import React, { useEffect, useState } from "react";
import CallAPI from "../../../adminpanel/components/commonComponents/AxiosHelper";
import { connect } from 'react-redux';
import DataTableComponent from "../commonComponents/DataTableComponent";
import LoadingComponent from '../commonComponents/LoadingComponent';
import { ModalSubmission, ReportModal } from "./ReportModal";
import Form from '../../../adminpanel/components/commonComponents/Form.v2'
import ModalComponent from '../../../adminpanel/components/commonComponents/ModalComponent'

const FetchReportComponent = ({ authData }) => {
    const [reportData, setReportData] = useState({
        data: [],
        enableSave: 0
    })
    const [errorMessage, setErrorMessage] = useState()
    const [modalToView, setmodalToView] = useState({})
    const [loadingStatus, setLoadingStatus] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            feather.replace();
        }, 2);
    }, [reportData, modalToView, loadingStatus])

    useEffect(() => {
        let params = { "siteId": authData.siteId };
        CallAPI('get', '/app/fetch_report_data', null, params, 0, function (response) {
            checkIfMaintenanceModeOn(response)
            if (response.status === true) {
                let tempArray = response.information
                setReportData({ ...reportData, data: tempArray });
                setErrorMessage(null);
            } else {
                setReportData({ ...reportData, data: response.status });
                setErrorMessage(response.error_message);
            }
        }, authData)
    }, [])

    const handleUpdate = (inputValue, rowNumber, data, columnName) => {
        let tempObject = [...tableData];
        let valueToCheck = 'reportName';
        tempObject.map(individualObj => {
            if (individualObj[valueToCheck] === data[valueToCheck]) {
                if (columnName == "frequency") {
                    individualObj["frequency"] = {
                        "freq_type": inputValue.type,
                        "timeOfDay": inputValue.time,
                        "dayOfWeek": inputValue.dayOfWeek,
                        "dayOfMonth": inputValue.dayOfMonth
                    }
                    individualObj["frequency"] = JSON.stringify(individualObj["frequency"]);
                } else {
                    individualObj[`${columnName}`] = inputValue[`${columnName}`];
                }
                if (individualObj['rockmetric_update_columns'] === null || individualObj['rockmetric_update_columns'] === undefined) {
                    individualObj['rockmetric_update_columns'] = [];
                }
                individualObj['rockmetric_update_columns'].push(columnName)
            }
        });
        setReportData({ data: tempObject, enableSave: 1 });
    }

    const handleSaveButton = (e) => {
        let params = {
            siteId: authData.siteId
        }
        let url = '/app/update_report_data';
        let postData = [];
        tableData.map(innerData => {
            if (innerData.rockmetric_update_columns) {
                postData.push({
                    "id": innerData.id,
                    "frequency": { "freq_type": JSON.parse(innerData.frequency).freq_type, "timeOfDay": JSON.parse(innerData.frequency).timeOfDay, "dayOfWeek": JSON.parse(innerData.frequency).dayOfWeek, "dayOfMonth": JSON.parse(innerData.frequency).dayOfMonth },
                    "toUser": innerData.toUser,
                    "isActive": innerData.isActive,
                    "rockmetric_update": innerData.rockmetric_update_columns ? true : false,
                    "rockmetric_update_columns": innerData.rockmetric_update_columns ? innerData.rockmetric_update_columns : []
                });
            }
        });
        setLoadingStatus(true);
        CallAPI('post', url, postData, params, 0, function (response) {
            if (response.information[0].status === true) {
                alert(response.information[0].information);
                setLoadingStatus(false);
                setReportData({ ...reportData, enableSave: 0 })
            } else {
                alert(response.error_message[0].information);
                setLoadingStatus(false);
                setReportData({ ...reportData, enableSave: 0 })
            }
        }, authData);
    }

    const openModal = (row, clickName) => {
        ReportModal(row, setmodalToView, clickName, authData);
    }

    const modalSubmission = (e) => {
        ModalSubmission(e, tableData, setReportData, authData, modalToView, setmodalToView)
    }

    let displayModal = null
    let filterForm = Object.keys(modalToView).length > 0 ? <Form label_array={modalToView.formData} /> : null;
    Object.keys(modalToView).length > 0 ? modalToView.modal['body'] = filterForm : null;
    displayModal = modalToView.modal && Object.keys(modalToView.modal).length > 0 ? <ModalComponent modalConfig={modalToView.modal} formSubmit={modalSubmission} /> : null;

    let errorData = <h5 className="text-center mg-t-100">{errorMessage != undefined ? errorMessage.replace("id","dataset") : errorMessage}</h5>
    let filterStatus = true;
    let topButton = [
        {
            "name": "Save",
            "className": `btn btn-primary btn-sm mg-r-10 text-white ${reportData.enableSave ? null : "disabled"}`,
            "event": handleSaveButton,
            "key": `executeData${Math.floor(Math.random() * 10)}`,
            "loadingStatus": loadingStatus,
            "type": "add",
            "icon": "pocket"
        }
    ];
    let columnData = [
        {
            "virtualName": "Report Name", "rawField": "reportName", type: "tableCell", tableCell: (row, id, column, index) => {
                return <>
                    <a type="button" href={row.url} target="_blank">{row["reportName"]}</a>
                </>
            }
        },
        { "virtualName": "Owner", "rawField": "userName", "type": "avtar" },
        { "virtualName": "Created Date", "rawField": "dateCreated", "displayType": "date" },
        { "virtualName": "Frequency", "rawField": "frequency", "edit": "mulitpleInput", "displayType": "both", "minWidth": "280px" },
        { "virtualName": "Type", "rawField": "type" },
        {
            "virtualName": "Status", "rawField": "isActive", "edit": "dropDown", "displayType": "dropDown", "options": {
                "1": { "name": "Active", "value": "1" },
                "0": { "name": "Inactive", "value": "0" }
            }
        },
        {
            "virtualName": "Shared", "rawField": "toUser", type: "tableCell", tableCell: (row, id, column, index) => {
                return <>
                    <span className="mg-l-10 mg-r-15">
                        <i className="fas fa-users mg-r-10 fa-lg"></i>
                        {row["toUser"] !== null ? isJson(row.toUser) ? JSON.parse(row.toUser).length : (row.toUser).split(',').length : 0}
                    </span>
                    <div className="dropdown-file" style={{ position: 'static' }}>
                        <a href="" className="dropdown-link" data-toggle="dropdown"><i title="Edit" className="fas fa-ellipsis-v"></i></a>
                        <div className="dropdown-menu">
                            <a href="javascript:void(0)" className="dropdown-item" onClick={openModal ? () => openModal(row, "downloadReport") : null}>
                                <i className="feather" data-feather='download-cloud'></i>Download Report
                            </a>
                            <a href="javascript:void(0)" className="dropdown-item" onClick={openModal ? () => openModal(row, "shareUser") : null}>
                                <i className="feather" data-feather='users'></i>Share Report
                            </a>
                        </div>
                    </div>
                </>
            }
        },
    ]
    let tableData = reportData.data ? reportData.data : null

    let top_filters = {
        "o_region": {
            "label": "Network Region",
            "options": [{ "label": "North", "display": "North", "id": "North", "value": "North;o_region", "type": "propertyValue" },
            { "label": "South", "display": "South", "id": "South", "value": "South;o_region", "type": "propertyValue" },
            { "label": "East", "display": "East", "id": "East", "value": "East;o_region", "type": "propertyValue" },
            { "label": "West", "display": "West", "id": "West", "value": "West;o_region", "type": "propertyValue" },
            { "label": "Blanks", "display": "Blanks", "id": "Blanks", "value": "Blanks;o_region", "type": "propertyValue" }]
        },
        "o_dealer_name": {
            "label": "Network Dealer Name",
            "options": [{ "label": "ABC10", "display": "ABC10", "id": "ABC10", "value": "ABC10;o_dealer_name", "type": "propertyValue" },
            { "label": "ABC5", "display": "ABC5", "id": "ABC5", "value": "ABC5;o_dealer_name", "type": "propertyValue" },
            { "label": "ABC9", "display": "ABC9", "id": "ABC9", "value": "ABC9;o_dealer_name", "type": "propertyValue" },
            { "label": "ABC1", "display": "ABC1", "id": "ABC1", "value": "ABC1;o_dealer_name", "type": "propertyValue" },
            { "label": "ABC2", "display": "ABC2", "id": "ABC2", "value": "ABC2;o_dealer_name", "type": "propertyValue" },
            { "label": "ABC3", "display": "ABC3", "id": "ABC3", "value": "ABC3;o_dealer_name", "type": "propertyValue" },
            { "label": "ABC4", "display": "ABC4", "id": "ABC4", "value": "ABC4;o_dealer_name", "type": "propertyValue" },
            { "label": "ABC7", "display": "ABC7", "id": "ABC7", "value": "ABC7;o_dealer_name", "type": "propertyValue" },
            { "label": "ABC8", "display": "ABC8", "id": "ABC8", "value": "ABC8;o_dealer_name", "type": "propertyValue" },
            { "label": "Vijay Auto", "display": "Vijay Auto", "id": "Vijay Auto", "value": "Vijay Auto;o_dealer_name", "type": "propertyValue" },
            { "label": "Blanks", "display": "Blanks", "id": "Blanks", "value": "Blanks;o_dealer_name", "type": "propertyValue" }
            ]
        }
    }

    let filterFlag = authData.companyName == 'Deloitte' ? true : false

    return (
        reportData.data && errorMessage === null ?
            <>
                <DataTableComponent
                    tableData={tableData}
                    setTableData={handleUpdate}
                    columnData={columnData}
                    addFilter={filterStatus}
                    filterColumnName={'reportName'}
                    topButton={topButton}
                    paginationStatus={true}
                    paginationPerPage={15}
                    topFiltersFlag={filterFlag}
                    topFiltersData={top_filters}
                />
                {displayModal}
            </>
            : reportData.data === false && errorMessage ? errorData : <LoadingComponent />
    )
}

function mapStateToProps(state) {
    return { authData: { ...state.dataSet.authData, ...{ "toolId": state.dataSet.dataSet.toolId } } };
}

export default connect(mapStateToProps, null)(FetchReportComponent);